// extracted by mini-css-extract-plugin
export var alertIcon = "_uf-0";